export default __webpack_public_path__ + "static/media/maintenance_started_on.fb321a5d.svg";